import {
  Box,
  Card,
  CardBody,
  CardFooter,
  Divider,
  Flex,
  Image,
  Stack,
  StackDivider,
  Text,
} from "@chakra-ui/react";
import moment from "moment/moment";
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function CardDetails({ data }) {
  const location = useLocation().pathname.split("/")[1];

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      w="80%"
      maxWidth={380}
    >
      <Card mb={4} w="100%">
        <CardBody>
          <Stack divider={<StackDivider />} spacing="2">
            <Flex alignItems="center">
              <Text
                fontSize="sm"
                textTransform="uppercase"
                fontWeight="semibold"
                color="gray.500"
              >
                {data.eventDetail?.eventName}
              </Text>
              {data.attend && (
                <Text
                  fontSize="sm"
                  marginLeft={3}
                  padding="1px 8px"
                  backgroundColor="#77DD77"
                  color="#fff"
                  borderRadius={6}
                >
                  Hadir
                </Text>
              )}
            </Flex>
            <Box>
              <Text fontSize="sm" textTransform="uppercase" color="gray.500">
                Tanggal & Waktu
              </Text>
              <Text pt={1} fontSize={12}>
                {moment(data.eventDetail?.date).format("dddd, DD MMMM YYYY")}
                {" | "}
                {`${data.eventDetail?.startTime} - ${data.eventDetail?.endTime}`}
              </Text>
            </Box>
            <Box>
              <Text fontSize="sm" textTransform="uppercase" color="gray.500">
                Tanggal & Waktu Pendaftaran
              </Text>
              <Text pt={1} fontSize={12}>
                {moment(new Date(data.registrationDate)).format(
                  "dddd, DD MMM yyyy | HH:mm"
                )}
              </Text>
            </Box>
          </Stack>
        </CardBody>
        <Divider />
        {location !== "inbox" && (
          <CardFooter justifyContent="center" p={2}>
            <Link to="/inbox">
              <Text fontSize={12} cursor="pointer" color="blue">
                Lihat Tiket
              </Text>
            </Link>
          </CardFooter>
        )}
      </Card>
      <Text fontSize={15} mt={3} mb={3} textAlign="center">
        Harap menunjukkan QR saat datang
      </Text>
      <Box border="1px solid gray" position="relative">
        <Image src={data.QR} alt="QR-image" />
      </Box>
    </Flex>
  );
}
